import {
  clearStoredFcmToken,
  requestWebFcmToken,
  subscribeToForegroundMessages,
} from "../services/firebaseMessaging";

export const DEVICE_ID_STORAGE_KEY = "device_id";

let initPushPromise = null;

export function getOrCreateDeviceId() {
  let deviceId = localStorage.getItem(DEVICE_ID_STORAGE_KEY);
  if (!deviceId) {
    deviceId =
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : `web-${Date.now()}-${Math.random().toString(16).slice(2)}`;
    localStorage.setItem(DEVICE_ID_STORAGE_KEY, deviceId);
  }
  return deviceId;
}

export function detectBrowser() {
  const ua = navigator.userAgent.toLowerCase();
  if (ua.includes("edg/")) return "edge";
  if (ua.includes("opr/") || ua.includes("opera")) return "opera";
  if (ua.includes("chrome") && !ua.includes("chromium")) return "chrome";
  if (ua.includes("firefox")) return "firefox";
  if (ua.includes("safari") && !ua.includes("chrome")) return "safari";
  if (ua.includes("brave")) return "brave";
  return "unknown";
}

export function getWebDevicePayload(extra = {}) {
  return {
    deviceType: "web",
    device_id: getOrCreateDeviceId(),
    browser: detectBrowser(),
    osVersion: navigator.platform || "",
    appVersion: process.env.REACT_APP_VERSION || "web",
    ...extra,
  };
}

export async function registerWebDeviceSession(api, { fcmToken } = {}) {
  const payload = getWebDevicePayload();
  if (fcmToken !== undefined) {
    payload.fcm_token = fcmToken;
  }
  return api.updateFcmToken(payload);
}

async function runWebPushInit(api) {
  subscribeToForegroundMessages();

  await registerWebDeviceSession(api);

  const fcmToken = await requestWebFcmToken();
  if (fcmToken) {
    console.log("[FCM] Web token obtained, syncing to session...");
    await registerWebDeviceSession(api, { fcmToken });
    console.log("[FCM] Web token synced to session.");
  } else {
    console.warn(
      "[FCM] No web token obtained (permission denied or unsupported).",
    );
  }

  return fcmToken;
}

/**
 * Ensures device session exists, requests browser notification permission,
 * registers FCM token, and listens for foreground messages.
 */
export function initWebPushNotifications(api) {
  const token = localStorage.getItem("token");
  if (!token) return Promise.resolve(null);

  if (!initPushPromise) {
    initPushPromise = runWebPushInit(api).catch((error) => {
      initPushPromise = null;
      throw error;
    });
  }

  return initPushPromise;
}

export function resetWebPushInit() {
  initPushPromise = null;
}

export async function logoutWebDeviceSession(api) {
  const deviceId = localStorage.getItem(DEVICE_ID_STORAGE_KEY);
  clearStoredFcmToken();
  resetWebPushInit();
  if (!deviceId) return null;
  return api.logout({ device_id: deviceId });
}
